/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum PhysicianScheduleAppointmentsDetailAliases {
  APPOINTMENT_DETAIL = 'appointment-detail',
  APPOINTMENT_DETAIL_DECK = 'appointment-detail-deck',
  APPOINTMENT_DETAIL_DECK_PANEL = 'appointment-detail-deck-panel',
  APPOINTMENT_DETAIL_FIELD = 'appointment-detail-field',
  APPOINTMENT_DETAIL_TITLE = 'appointment-detail-title',
  APPOINTMENT_DETAIL_TITLE_PANEL = 'appointment-detail-title-panel',
  APPOINTMENTS_DETAIL_CONTEXTUAL_BAR = 'appointments-detail-contextual-bar',
  APPOINTMENTS_DETAIL_LAYOUT = 'appointments-detail-layout',
  BUTTON_PEP = 'button-pep',
}
export { PhysicianScheduleAppointmentsDetailAliases };
